import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { 
  initializeFirestore, 
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  runTransaction // Add this import
} from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase configuration (replace with your own config)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "dental-invoice-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_APP_MEASUREMENT_ID
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Debug logging to verify Firebase project configuration
if (process.env.NODE_ENV === 'development') {
  console.log('Firebase App Config:', {
    projectId: app.options.projectId,
    authDomain: app.options.authDomain,
    apiKey: app.options.apiKey?.substring(0, 10) + '...' // Partial for security
  });
}

// Initialize other Firebase services
const analytics = getAnalytics(app);
setAnalyticsCollectionEnabled(analytics, true); // Fixed: Use imported function

const auth = getAuth(app);
const db = getFirestore(app);

// Initialize Firebase Functions
const functions = getFunctions(app);

// Connect to emulator in development
if (process.env.NODE_ENV === 'development') {
  try {    // Only connect if not already connected
    if (!functions._delegate._url) {
      connectFunctionsEmulator(functions, 'localhost', 5001);
      if (process.env.NODE_ENV === 'development') {
        console.log('Connected to Functions emulator');
      }
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Functions emulator connection failed or already connected:', error.message);
    }
  }
}

// CRITICAL FIX: Only connect to emulator when explicitly enabled
const shouldUseEmulator = process.env.NODE_ENV === 'development' && 
                         process.env.REACT_APP_USE_EMULATOR === 'true' && 
                         window.location.hostname === 'localhost';

if (shouldUseEmulator) {
  if (process.env.NODE_ENV === 'development') {
    console.log('Connecting to Functions emulator with:', {
      host: 'localhost',
      port: 5001,
      projectId: firebaseConfig.projectId
    });
  }
    try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    if (process.env.NODE_ENV === 'development') {
      console.log('Successfully connected to Functions emulator');
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error connecting to Functions emulator:', error);
    }
  }
} else {
  if (process.env.NODE_ENV === 'development') {
    console.log('Using production Firebase Functions - emulator NOT connected');
  }
}

// Set persistence to local
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error setting persistence:', error);
    }
  });

// Export everything once at the end
export { auth, db, functions, app }; // Add app to exports
export default app;
